import React from 'react';

import { PermissionName } from 'generated/graphql';
import { permissionUtil } from 'modules/layer00';



export interface IProps {
  storeId?: string;
  requiresPermissions: PermissionName[];
  requiresOneOfPermission?: PermissionName[];
  children: React.ReactNode | React.ReactNode[];

  evaluationCriteria?: permissionUtil.IEvaluationCriteria;
}

export const FC: React.FC<IProps> = props => {
  const [evaluatePermission, loading] = permissionUtil.usePermissions({
    // Sometimes the store is an empty string. this should not be passed to the server.
    storeId: props.storeId || undefined
  });



  const hasPermission = React.useMemo(
    () => evaluatePermission(props.requiresPermissions),
    [
      evaluatePermission,
      props.requiresPermissions
    ]
  );

  return !loading && hasPermission ? (
    <>
      {props.children}
    </>
  ) : null;
};
